export const VEHICLES = {
  TM28RYY: {
    licensePlate: 'TM28RYY',
    imei: '6028016410',
    routeId: '6fc2381f-2b34-4eba-a709-ff46c945f56a'
  },
  TM37FUG: {
    licensePlate: 'TM37FUG',
    imei: '6028024308',
    routeId: '3badb7b2-aa00-43eb-b0df-1ac79fc60056'
  }
}

export const getVehicleByRouteId = (routeId) => {
  return Object.values(VEHICLES).find(vehicle => vehicle.routeId === routeId)
}